import { css } from 'lit'

export const voyageWeatherLmitsStyles = [
    css`
        :host {
          font-family: MaerskText;
          align-items: center;
        }
        .container {
          position: sticky;
          width: 98vw;
          z-index: 1000;
          background-color: white;
        }
        .content {
          padding-bottom: 1.5rem;
        }
        .table-container {
          width: 98%;
          margin: 0 auto;
          border: 1px solid var(--neutrals-grey-07);
          border-radius: 8px;
          background-color: var(--neutrals-grey-10);
        }
        .header-container {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-left: 20px;
        }

        th {
          color: black;
          background: var(--neutrals-grey-09);
          text-align: center;
          padding: 8px;
          border-bottom: 1px solid var(--neutrals-grey-07);
          border-right: 1px solid var(--neutrals-grey-07);
          font-size: 12px;
        }
        .header {
          margin-top: 5px;
          color: black;
        }
        .header-right {
          text-align: left;
        }
        .connected {
          min-width: 250px;
        }
        .connected::before {
          content: "";
          box-sizing: border-box;
          position: absolute;
          bottom: 50%;
          width: 10px;
          height: 36px;
          border-bottom: 1px solid var(--neutrals-grey-05, grey);
        }
        .policy-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          grid-column-gap: 10px;
        }
        .legend {
          margin-top: 0;
          text-align: right;
          color: var(--neutrals-grey-02, black);
          font-size: 16px;
          font-weight: bold;
        }
        .cell {
          padding-right: 16px;
          width: 200px;
          font-size: 16px;
        }
        .policy-legend {
          grid-column: span 3;
        }

        #footer {
          width: 100%;
          display: flex;
          justify-content: flex-end;
        }
        .footerButton {
          margin-top: 12px;
          margin-bottom: 12px;
          height: 32px;
          min-width: 80px;
          font-size: 14px;
          font-family: var(--component-paragraph-ff, serif);
          padding: 0px 12px 0px 12px;
          background: none;
          border: none;
          outline: none;
          cursor: pointer;
          border-radius: 3px;
        }
        .cancel {
          color: var(--neutrals-grey-02);
          margin-right: 10px;
          border: 1px solid var(--neutrals-grey-06, grey);
        }
        .footerButton.accept {
          background: rgba(20, 20, 20, 1);
          margin-right: 20px;
          color: var(--neutrals-grey-10, white);
        }

        .footerButton.accept.disabled {
          background: rgba(100, 100, 100, 1);
          cursor: not-allowed;
        }
        .radio-button-display {
          display: flex;
          justify-content: flex-end;
          align-items: center;
          padding-bottom: 5px;
          padding-right: 20px;
          margin-left: 19px;
        }
        .radio-button-display p {
          margin: 0 10px 0 0;
        }
        .radio-button-display input[type="radio"] {
          margin: 0 5px;
        }
        input:disabled {
          color: var(--neutrals-grey-04, grey);
        }
        .inputContainer {
          border-top: 1px solid var(--neutrals-grey-07);
          text-align: left;
        }
        .name {
          text-align: left;
          padding: 12px;
          /* width: 25%; */
          color: var(--neutrals-grey-02, black);
          border-top: 1px solid var(--neutrals-grey-07);
        }

        .periodInput input {
          background-color: transparent;
          font-size: 16px;
          width: 95px;
        }
        .dropdown {
          box-sizing: border-box;
          border: none;
          border-radius: 2.5px;
          font-family: MaerskText;
          color: var(--neutrals-grey-02, black);
          background-color: var(--neutrals-grey-10, white);
        }
        
        .numberInput {
          width: 150px;
          text-align: left;
          height: 34px;
          box-sizing: border-box;
          border: none;
          color: var(--neutrals-grey-02, black);
          background-color: unset;
          font-family: MaerskText;
        }
         .periodInput {
          display: flex;
          border: none;
          align-items: center;
          width: 300px;
        }
        .numberInput:invalid {
          background: #ffcccb;
          width: 120px;
          border-radius: 5px;
        }
        .inlineInput:invalid {
          background: #ffcccb;
          width: 80px;
          border-radius: 5px;
        }
        .numberInput[invalid]::after {
          content: attr(data-tooltip);
          position: absolute;
          bottom: -25px;
          left: 50%;
          transform: translateX(-50%);
          background-color: rgba(0, 0, 0, 0.75);
          color: white;
          padding: 5px 10px;
          border-radius: 4px;
          font-size: 12px;
          white-space: nowrap;
          display: none;
        }
        .numberInput[invalid]:hover::after {
          display: block;
        }
        .numberInput:focus-within {
          outline: none;
        }
        .periodInput:focus-within {
          outline: none;
        }
        .inlineInput:focus-within {
          outline: none;
        }
        .dropdown:focus-within {
          outline: none;
        }
        .inlineInput {
          border: none;
          padding-left: 5px;
          color: var(--neutrals-grey-02, black);
          background-color: unset;
          font-size: 14px;
          font-family: MaerskText;
          .size {
            padding-right: 20px;
          }
        }
        .size {
          padding-right: 20px;
        }
        .closeButton {
          position: absolute;
          border: none;
          font-size: 15px;
          top: 21px;
          right: 10px;
          background: white;
          cursor: pointer;
          color: var(--neutrals-grey-04, grey);
        }
        .number-input {
          display: flex;
          gap: 10px;
          align-items: center;
        }
        .breadcrumb-container {
          display: inline-block;
          padding: 7px;
          border: 1px solid #ddd;
          border-radius: 4px;
          width: auto;
          margin-left: 18px;
        }
        .padding {
          padding-right: 10px;
        }
        .footer-text {
          color: rgba(0, 150, 135, 1);
          margin-left: 18px;
          padding-top: 5px;
        }
        .footer-text-invalid {
          color: rgba(255, 0, 0, 1);
          margin-left: 18px;
          padding-top: 5px;
        }
        .questionCircle {
          color: red;
        }

        table {
          border-collapse: separate;
          border-spacing: 0;
          width: 100%;
          overflow: auto;
          border: 1px solid #ccc;
          border-radius: 10px;
        }

        th,
        td {
          border-bottom: 1px solid #ccc;
          padding: 8px;
          text-align: left;
          vertical-align: middle;
          word-wrap: break-word;
        }

        thead th {
          background-color: #f3f3f3;
          font-weight: bold;
        }

        td.readonly {
          background-color: #f9f9f9;
          color: #666;
          font-style: italic;
        }

        input[type="text"] {
          width: 100%;
          box-sizing: border-box;
          padding: 4px;
          border: 1px solid #ccc;
        }
        .table-wrapper {
          max-width: 98%;
          overflow-x: auto;
          table-layout: auto;
          overflow-wrap: break-word;
          margin-left: 20px;
        }

        .policy-header {
          min-width: 105px;
        }
        .add-imo {
          display: flex;
        }
        .fab-container {
          position: fixed;
          bottom: 24px;
          left: 24px;
          display: flex;
          align-items: flex-end;
          z-index: 1000;
        }

        .input-float {
          margin-bottom: 8px;
          padding: 8px;
          font-size: 14px;
          width: 200px;
          border: 1px solid #ccc;
          border-radius: 6px;
        }

        .fab {
          width: 56px;
          height: 56px;
          border-radius: 50%;
          background-color: #00243d;
          color: white;
          border: none;
          font-size: 24px;
          box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
          cursor: pointer;
          transition: all 0.2s ease;
        }
        .fab-input {
          width: 100px;
          height: 56px;
          background-color: #42b0d5;
          color: white;
          border: none;
          font-size: 14px;
          box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
          cursor: pointer;
          transition: all 0.2s ease;
        }

        .fab.expanded {
          width: auto;
          padding: 0 16px;
          border-radius: 28px;
          font-size: 16px;
        }

        .fab:hover {
          background-color: #00243d;
        }

        .imo-input {
            height: 100px;
            width: 200px;
            border: 1px solid #42b0d5;
            border-radius: 5px;
            padding: 16px;
        }

        .sticky-col1{
            position: sticky;
            left: 0;
            background-color: #ffffff;
            z-index: 1;
        }
       
        .sticky-col2 {
            position: sticky;
            left: 70px;
            background-color: #ffffff;
            z-index: 1;
        }

        .sticky-col3 {
            position: sticky;
            left: 156px;
            background-color: #ffffff;
            z-index: 1;
            box-shadow: 2px 0 5px -2px rgba(0, 0, 0, 0.3);
        }

         .sticky-header{
            background-color: #f3f3f3;
        }

        .right-border{
            border-right: 1px solid var(--neutrals-grey-07);
        }
        .view-switch{
            margin-right: 20px;
        }

        .services-pills-wrapper {
              display: flex;
              flex-wrap: wrap;
              flex-direction: row;
              gap: 16px;
              margin-top: 12px;
            }
            .services-pills-wrapper[visible] {
              padding-top: 16px;
            }

            .pill {
              background-color: #ededed;
              padding: 2px 8px 3px;
              border-radius: 36px;
              display: flex;
              flex-direction: row;
              gap: 4px;
              align-items: center;
            }
            .pill > span {
              font-family: MaerskText;
              font-size: 12px;
              text-align: center;
              color: var(--neutrals-grey-02, gray);
            }
            .pill .pill-close-btn {
              background: none;
              border: none;
              outline: none;
              cursor: pointer;
              fill: var(--neutrals-grey-02, black);
              padding: 0px;
            }
            .pill .pill-close-btn > svg {
              display: block;
              width: 8px;
              top: 1px;
              position: relative;
            }
            .limits-non-editable{
              cursor: not-allowed;
              color: var(--neutrals-grey-04, grey);
            }
    `,
]
